import React from "react";

const glance = [
  { term: "Now", detail: "Senior Consultant, Baker Tilly US" },
  { term: "Stack", detail: "C#, ASP.NET Core, Blazor, Azure" },
  { term: "Certified", detail: "AZ-204 · AZ-900" },
  { term: "Based in", detail: "Brookings, SD · remote" },
];

export default function Hero() {
  return (
    <div className="mx-auto max-w-page px-5 pb-16 pt-10 md:px-10 md:pb-24 md:pt-16">
      <p className="label flex flex-wrap gap-x-3 text-ink-soft">
        <span>Senior Software Consultant</span>
        <span aria-hidden="true" className="text-vermilion">/</span>
        <span>.NET &amp; Azure</span>
      </p>

      <h1 className="display mt-6 font-serif text-[clamp(3.5rem,15vw,11.5rem)] font-black leading-[0.86] tracking-[-0.04em]">
        Garrett
        <br />
        <span className="italic font-light">Freeman</span>
        <span className="text-vermilion">.</span>
      </h1>

      <div className="mt-10 grid gap-10 border-t border-ink pt-8 md:mt-14 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-7">
          <p className="max-w-xl text-xl leading-snug md:text-2xl">
            7+ years delivering .NET and Azure applications end to end for enterprise clients, from requirements and architecture through deployment, documentation, and training.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 font-mono text-sm">
            <a
              href="mailto:contact@garrettfreeman.com"
              className="bg-ink px-4 py-3 text-paper transition-colors hover:bg-vermilion hover:text-ink"
            >
              contact@garrettfreeman.com →
            </a>
            <a
              href="https://www.linkedin.com/in/garrett-freeman/"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/Garrett-Freeman"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              GitHub
            </a>
          </div>
        </div>

        <dl className="md:col-span-4 md:col-start-9">
          {glance.map((row) => (
            <div
              key={row.term}
              className="grid grid-cols-[6rem_1fr] gap-4 border-b border-ink/25 py-3 first:pt-0"
            >
              <dt className="label pt-1 text-ink-soft">{row.term}</dt>
              <dd className="text-base leading-snug">{row.detail}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
